import axios, { AxiosInstance, AxiosResponse } from "axios";
import { MediaUploadFileIdResponse } from "../@types/DRO/MediaUploadResponse";
export class MediaUploadApi {
  public static api = new MediaUploadApi();
  private instance: AxiosInstance;

  constructor() {
    this.instance = axios.create({
      // baseURL: process.env.REACT_APP_ZYPP_UPLOAD_API_URL,
      baseURL: "https://manager.bcykal.com/mobycy/payout-manager",
      headers: {
        "Content-Type": "application/json",
      },
    });
  }
  getToken() {
    return localStorage.getItem("token");
  }
  mediaUploadFileId(
    file: File
  ): Promise<AxiosResponse<MediaUploadFileIdResponse>> {
    const formData = new FormData();
    formData.append("file", file);

    return this.instance.post<MediaUploadFileIdResponse>(
      "/media/upload",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${this.getToken()}`,
        },
      }
    );
  }
  async uploadFileAndPayoutSheet(file: File, type: number): Promise<void> {
    try {
      const uploadResponse = await this.mediaUploadFileId(file);
      const fileId = uploadResponse.data.fileId;
      await this.instance.post<any>(
        `/pilot/payout/files?fileId=${fileId}&type=${type}`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.getToken()}`,
          },
        }
      );
      console.log("Payout sheet uploaded successfully.");
    } catch (error) {
      console.error("Error uploading payout sheet:", error);
    }
  }
  async getFileUrl(fileId: number): Promise<string> {
    try {
      const response = await this.instance.get(`/media/get`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
        params: {
          fileId: fileId,
        },
      });
      return response.data.fileUrl;
    } catch (error) {
      console.error("Error fetching file URL:", error);
      throw error;
    }
  }
}
